// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// ANTD
import Button from 'antd/lib/button';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import notification from 'antd/lib/notification';
// APOLLO
import { graphql, compose } from 'react-apollo';
import revokeGoogleCalAccess from 'ApolloClient/Mutations/revokeGoogleCalAccess';

const styles = {
  container: {
    border: '1px solid #efefef',
    borderLeft: '5px solid #4082f1',
    minHeight: 115,
    padding: 15,
    width: 550,
    maxWidth: '100%',
  },
};

class GoogleCalConnected extends React.PureComponent {
  handleRevoke = async () => {
    try {
      await this.props.revokeGoogleCalAccess({
        variables: {},
        // refetchQueries: [{ query: GET_USER_DATA }],
      });
      notification.success({ message: 'Google calendar access revoked!' });
    } catch (exc) {
      console.log(exc);
      notification.error({ message: exc });
    }
  };

  render() {
    return (
      <div>
        <Row type="flex" align="middle" justify="center" style={styles.container}>
          <Col
            xs={24}
            sm={16}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              textAlign: 'left',
            }}
          >
            <img
              src="https://www.easypractice.net/wp-content/uploads/2016/11/Google_2015_logo.svg_-950x296.png"
              style={{ maxHeight: 75 }}
            />
          </Col>
          <Col xs={24} sm={8} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <a target="_blank" href="https://calendar.google.com/calendar">
              <Button size="large" style={{ background: '#4082f1', color: 'white' }}>
                VIEW CALENDAR
              </Button>
            </a>
          </Col>
          <Col xs={24} />
        </Row>
        <a
          href=""
          onClick={evt => {
            evt.preventDefault();
            this.handleRevoke();
          }}
        >
          Revoke HeyNed Access
        </a>
      </div>
    );
  }
}

GoogleCalConnected.propTypes = {
  revokeGoogleCalAccess: PropTypes.func.isRequired,
};

const enhance = compose(graphql(revokeGoogleCalAccess, { name: 'revokeGoogleCalAccess' }));

export default enhance(GoogleCalConnected);



// WEBPACK FOOTER //
// ./src/routes/app-studio/IntegrationsArea/GoogleCalConnected/index.js